import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import Pagination from '../components/Pagination';
import { roleLabel } from '../utils/roles';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  // Só na edição: conta nova ainda não tem vínculo com o Entra
  const identidadeTravada = Boolean(editing?.identidade_do_tenant);
  const [form, setForm] = useState({ name: '', email: '', role: 'Padrao', groups: [], language: 'pt', is_active: true });
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState('');
  const [generatedPassword, setGeneratedPassword] = useState('');

  useEffect(() => { loadUsers(); }, [page, search]);
  useEffect(() => { loadGroups(); }, []);

  async function loadUsers() {
    const { data } = await api.get('/users', { params: { page, search: search || undefined, limit: 15 } });
    setUsers(data.data); setTotal(data.total);
  }
  async function loadGroups() { try { const { data } = await api.get('/groups'); setGroups(data.data); } catch {} }

  function openCreate() { setEditing(null); setForm({ name: '', email: '', role: 'Padrao', groups: [], language: 'pt', is_active: true }); setGeneratedPassword(''); setError(''); setShowModal(true); }
  function openEdit(u) { setEditing(u); setForm({ name: u.name, email: u.email, role: u.role, groups: u.groups?.map((g) => g.id) || [], language: u.language || 'pt', is_active: u.is_active }); setGeneratedPassword(''); setError(''); setShowModal(true); }

  async function handleSave() {
    setError('');
    try {
      if (editing) {
        // Campos travados ficam de fora do envio: o servidor os recusaria e a
        // edicao de papel e grupos falharia junto, sem motivo aparente.
        const { name, email, ...resto } = form;
        await api.put(`/users/${editing.id}`, editing.identidade_do_tenant ? resto : form);
      }
      else { const { data } = await api.post('/users', form); if (data.generated_password) { setGeneratedPassword(data.generated_password); return; } }
      setShowModal(false); loadUsers();
    } catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }
  async function handleToggleActive(u, ativar) {
    setError('');
    const aviso = ativar
      ? `Reativar ${u.name}? A pessoa volta a ter acesso com o mesmo papel.`
      : `Desativar ${u.name}? O acesso e encerrado na hora e as sessoes abertas caem. `
        + 'O historico de revisoes, aprovacoes e leituras e preservado.';
    if (!window.confirm(aviso)) return;
    try {
      await api.put(`/users/${u.id}`, { is_active: ativar });
      loadUsers();
    } catch (err) { setError(err.response?.data?.error || 'Erro'); }
  }
  async function handleResetPassword(id) { if (!window.confirm('Resetar senha?')) return; const { data } = await api.post(`/users/${id}/reset-password`); alert(`Nova senha: ${data.password}`); }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-bold tracking-tight">Usuários</h1>
        <button className="btn btn-primary" onClick={openCreate}>Novo Usuário</button>
      </div>

      <div className="bg-surface-100 border rounded-md p-4">
        <div className="flex gap-3 mb-4">
          <input className="form-input flex-1" placeholder="Buscar..." value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
        </div>
        <table className="w-full border-collapse">
          <thead><tr className="border-b">
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Nome</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Email</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Função</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Status</th>
            <th className="text-left text-2xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2">Ações</th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-subtle hover:bg-surface-inset">
                <td className="px-3 py-3 font-medium">{u.name}</td>
                <td className="px-3 py-3 text-sm text-ink-muted">{u.email}</td>
                <td className="px-3 py-3"><span className="doc-code">{roleLabel(u.role)}</span></td>
                <td className="px-3 py-3">
                  <span className={`text-xs font-semibold ${u.is_active ? 'text-status-approved' : 'text-status-rejected'}`}>
                    {u.is_active ? 'Ativo' : 'Inativo'}
                  </span>
                </td>
                <td className="px-3 py-3">
                  <div className="flex gap-1">
                    <button className="btn btn-sm btn-secondary" onClick={() => openEdit(u)}>Editar</button>
                    <button className="btn btn-sm btn-secondary" onClick={() => handleResetPassword(u.id)}>Reset</button>
                    {/* Nao ha exclusao: apagar o usuario levava junto as
                        revisoes, aprovacoes e leituras que ele assinou.
                        Desativar corta o acesso e preserva o historico. */}
                    {u.is_active
                      ? <button className="btn btn-sm btn-danger" onClick={() => handleToggleActive(u, false)}>Desativar</button>
                      : <button className="btn btn-sm btn-secondary" onClick={() => handleToggleActive(u, true)}>Reativar</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination page={page} total={total} limit={15} onPageChange={setPage} />
      </div>

      {showModal && (
        <Modal title={editing ? 'Editar Usuário' : 'Novo Usuário'} onClose={() => setShowModal(false)}>
          {error && <div className="p-3 rounded-md text-sm mb-4 bg-status-rejected/10 text-status-rejected border border-status-rejected/20">{error}</div>}
          {generatedPassword ? (
            <div className="p-3 rounded-md text-sm mb-4 bg-status-approved/10 text-status-approved border border-status-approved/20">
              Senha gerada: <strong className="font-mono">{generatedPassword}</strong><br />Anote esta senha.
            </div>
          ) : (
            <>
              {/* Conta vinda do Entra: identidade pertence ao tenant, e o
                  servidor recusa alteracao mesmo vinda de Administrador. */}
              <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Nome</label>
                <input className={`form-input${identidadeTravada ? ' opacity-50' : ''}`} value={form.name}
                  disabled={identidadeTravada}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Email</label>
                <input className={`form-input${identidadeTravada ? ' opacity-50' : ''}`} type="email" value={form.email}
                  disabled={identidadeTravada}
                  onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>

              {identidadeTravada && (
                <p className="text-xs text-ink-muted -mt-2 mb-4">
                  Nome e e-mail vem do Microsoft Entra ID e sao atualizados a cada login
                  desta pessoa. Altere no Microsoft 365. Papel, grupos e situacao continuam
                  editaveis aqui.
                </p>
              )}
              <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Função</label>
                <select className="form-select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
                  {/* value = o que vai para o banco; texto = o que a pessoa le */}
                  <option value="Padrao">Padrão</option>
                  <option value="Manutencao">Manutenção</option>
                  <option value="Administrador">Administrador</option>
                  <option value="Auditoria">Auditoria (somente leitura)</option>
                </select></div>
              <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Grupos</label>
                <select className="form-select min-h-[80px]" multiple value={form.groups}
                  onChange={(e) => setForm({ ...form, groups: Array.from(e.target.selectedOptions, (o) => o.value) })}>
                  {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
                </select></div>
              <div className="mb-4"><label className="block text-sm font-medium text-ink-secondary mb-1">Idioma</label>
                <select className="form-select" value={form.language} onChange={(e) => setForm({ ...form, language: e.target.value })}>
                  <option value="pt">Portugues</option><option value="en">Ingles</option><option value="es">Espanhol</option>
                  <option value="ar">Arabe</option><option value="zh">Chines</option>
                </select></div>
              {editing && (
                <div className="mb-4"><label className="flex items-center gap-2 text-sm">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} /> Ativo
                </label></div>
              )}
            </>
          )}
          <div className="flex gap-3 justify-end mt-5">
            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>{generatedPassword ? 'Fechar' : 'Cancelar'}</button>
            {!generatedPassword && <button className="btn btn-primary" onClick={handleSave}>Salvar</button>}
          </div>
        </Modal>
      )}
    </div>
  );
}
